module.exports = __webpack_public_path__ + "img/LePetitSavant.9ae824f3.jpeg";